const wholeDollars = new Intl.NumberFormat('en-US')

/**
 * The points explainer shown on Alfie and Borrower Portal rate cards: the
 * discount points as a percentage of the loan amount and what they cost.
 */
export function pointsTooltipText(
  discountPoints: number,
  loanAmount: number
): string {
  const loanAmountDollars = wholeDollars.format(Math.round(loanAmount))
  const pointsDollarAmount = wholeDollars.format(
    Math.round(loanAmount * (discountPoints / 100))
  )

  return `${discountPoints} points = ${discountPoints}% x $${loanAmountDollars}. These points will cost $${pointsDollarAmount} in upfront payment to reduce the rate.`
}
